module.exports = __webpack_public_path__ + "img/IcnFb.2cf8cf2f.png";